import React from "react";
import Page from "components/Page";
import { ClientCompaniesListProps } from "./ClientCompaniesList.types";
import { lazyWithRetry } from "helpers/lazyWithRetry";

const ClientCompaniesList = lazyWithRetry(() => import("./ClientCompaniesList"));

export default (props: ClientCompaniesListProps) => (
  <Page>
    <ClientCompaniesList {...props} />
  </Page>
);
